import { Component, OnInit, HostBinding, Input, EventEmitter, Output } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { ModalShareComponent } from 'app/shared/components/modal-share/modal-share.component';
import { ModalContactComponent } from 'app/shared/components/modal-contact/modal-contact.component';
import { slideInUpStagger } from 'app/shared/animations/slide-in-up-stagger.animation';
import { FileType } from 'app/models/file-type.enum';
import { FilesService } from 'app/services/files.service';
import * as FileSaver from 'file-saver';
import { SharepointContent } from 'app/models/sharepoint-data';
import { Source } from 'app/models/source.enum';
import {GoogleTagManagerService} from '../../../services/google-tag-manager.service';

@Component({
  selector: 'app-asset-action',
  templateUrl: './asset-action.component.html',
  styleUrls: ['./asset-action.component.scss'],
  providers: [ FilesService ],
  animations: [
    slideInUpStagger('stagger-elem', '1.5rem', '.7', 'hoverOn')
  ],
})
export class AssetActionComponent implements OnInit {
  @HostBinding('@slideInUpStagger')
  @Input() status: string;
  @Input() asset: any;
  @Input() type: string;
  @Output() download: EventEmitter<any> = new EventEmitter();
  bsModalRef: BsModalRef;
  statusDropdown: { isopen: boolean } = { isopen: false };
  typeVideo: string = FileType.Video;

  constructor(
    private modalService: BsModalService,
    private fileService: FilesService,
    private gtmService: GoogleTagManagerService,
  ) {}

  onDownload() {
    if (this.isFile()) {
      const id = this.asset.source === Source.Document ? this.asset.id : this.asset.documentId;
      if (id) {
        this.fileService
        .download(id)
        .subscribe((result) => FileSaver.saveAs(result.content, result.name));
      }
      this.gtmService.pushEvent(`Download - ${this.asset.displayName}`);
    } else {
      this.download.emit(this.asset);
    }
  }

  contact(): void {
    this.showModal(ModalContactComponent);
  }

  share(): void {
    if (this.isFile()) {
      this.gtmService.pushEvent(`Share intention - ${this.asset.displayName}`);
    } else {
      // Changed until new tag plan resolvement
      this.gtmService.pushEvent(`Share intention - ${this.asset.displayName}`);
    }
    this.showModal(ModalShareComponent);
  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }

  change(value: boolean): void {
    this.statusDropdown.isopen = value;
  }

  isFile(): Boolean {
    return [Source.Image, Source.Video, Source.PDF, Source.Onboarding, Source.Document]
      .indexOf(this.asset.source) !== -1;
  }

  private showModal(component: any) {
     this.asset.sharingType=this.type;
    this.bsModalRef = this.modalService.show(component, {
      class: 'modal-lg',
      backdrop: 'static'
    });
    this.bsModalRef.content.data = this.asset;
  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/asset-action/asset-action.component.ts